export class OptionalCost {
    
    name;
    cost;
    maxQuantity;
    addsToPatronCount;

    constructor(json) {
        if (json) {
            this.name = json.name;
            this.cost = json.cost;
            this.addsToPatronCount = json.addsToPatronCount;
            if (json.maxQuantity)
                this.maxQuantity = json.maxQuantity;
            else
                this.maxQuantity = 1;       // default to 1 if not set (backwards compatibility)
        }
    }

    static initNew() {
        const oc = new OptionalCost();
        oc.name = "";
        oc.cost = 0;
        oc.maxQuantity = 1;
        oc.addsToPatronCount = false;
        return oc;
    }

    copy() {
        const copy = new OptionalCost();
        copy.name = this.name;
        copy.cost = this.cost;
        copy.maxQuantity = this.maxQuantity;
        copy.addsToPatronCount = this.addsToPatronCount;
        return copy;
    }
}
